import {
	WeaTools
} from 'ecCom'

export const getOrgVirtualData = (params) => WeaTools.callApi('/api/hrm/orgchart/getOrgVirtualData', 'POST', params)

export const getOrgChartSet = (params) => WeaTools.callApi('/api/hrm/orgchart/getOrgChartSet', 'POST', params)

export const getTab = (params) => WeaTools.callApi('/api/hrm/orgchart/getTab', 'POST', params)

export const getOrgChartSearchCondition = (params) => WeaTools.callApi('/api/hrm/orgchart/getOrgChartSearchCondition', 'POST', params)

export const getOrgChartData = (params) => WeaTools.callApi('/api/hrm/orgchart/getOrgChartData', 'POST', params)

export const getOrgChartDataAjax = (params) => WeaTools.callApi('/api/hrm/orgchart/getOrgChartDataAjax', 'POST', params)

export const initData = (params = {}) => Promise.all([getOrgVirtualData(), getOrgChartSet(), getTab()])


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/orgChart.js